export default __webpack_public_path__ + "static/media/barcelona2.914658ee.glb";